module.exports = __webpack_public_path__ + "img/cangetincome.bbc6ec19.svg";